var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinGray1418 = function SvgPinGray1418(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    d: "M7 17.333q-.301 0-.604-.107a1.6 1.6 0 0 1-.539-.324 34 34 0 0 1-2.48-2.523 19 19 0 0 1-1.8-2.382 11.3 11.3 0 0 1-1.1-2.22Q.103 8.707.102 7.738q0-3.234 2.08-5.153 2.08-1.92 4.82-1.92 2.737 0 4.818 1.92t2.08 5.153q0 .97-.377 2.037a11.3 11.3 0 0 1-1.1 2.22 19 19 0 0 1-1.8 2.383q-1.077 1.23-2.48 2.523a1.6 1.6 0 0 1-.538.323 1.8 1.8 0 0 1-.604.108m0-8.042q.711 0 1.218-.507.507-.506.507-1.218 0-.711-.507-1.218A1.66 1.66 0 0 0 7 5.841q-.711 0-1.218.507a1.66 1.66 0 0 0-.507 1.218q0 .711.507 1.218T7 9.291"
  })));
};
export default SvgPinGray1418;